import { graphql } from '../../../gql';

export const GET_POST_SUMMARY = graphql(`
  query getPostSummary($postId: ID!) {
    getPostSummary(postId: $postId) {
      id
      title
      teaser
      author { username userId }
      score
      readTime
      categories
    }
  }
`);
